import {
  BulkMakeupActivityRequest,
  LoadingMakeupActivityState,
  MakeupActivityRequest,
  MakeupActivityScheduleRequest,
} from '@tsin-core/models/makeup-activity.model';

export class GetMakeupActivities {
  static readonly type = '[MakeupActivity] Get Makeup Activities By Schedule and Session';
  constructor(public payload: MakeupActivityScheduleRequest) {}
}

export class GetMakeupActivitiesByWeekly {
  static readonly type = '[MakeupActivity] Get Makeup Activities By Weekly Schedule';
  constructor(public payload: string) {}
}

export class UpdateMakeupActivity {
  static readonly type = '[MakeupActivity] Update';
  constructor(public payload: MakeupActivityRequest) {}
}

export class SetMakeupActivityLoading {
  static readonly type = '[MakeupActivity] Set Loading';
  constructor(public loading: LoadingMakeupActivityState) {}
}

export class SetMakeupActivityError {
  static readonly type = '[MakeupActivity] Set Error';
  constructor(public error: string | null) {}
}

/**
 * Submit makeup activity status for multiple learners in a single request.
 * Soumettre le statut de rattrapage pour plusieurs apprenants en une seule requête.
 */
export class BulkMakeupActivity {
  static readonly type = '[MakeupActivity] Bulk Mark Completed';
  constructor(public payload: BulkMakeupActivityRequest) {}
}
